(function(){
 'use strict';
 const enabled=document.currentScript?.dataset.enabled==='true';
 function publish(name,data){
  if(!enabled)return;
  const shopify=window.Shopify;
  if(!shopify?.customerPrivacy?.analyticsProcessingAllowed?.()||!shopify?.analytics?.publish)return;
  try{Promise.resolve(shopify.analytics.publish('midnight:'+name,data)).catch(()=>{});}catch{}
 }
 // Only discovery counts and control names. Never send search text, email, photos or measurements.
 window.addEventListener('midnight:discovery',event=>{
  const d=event.detail||{};
  if(d.kind==='results')publish('collection_results',{result_count:Number(d.count)||0,has_search:!!d.hasSearch,has_filters:!!d.hasFilters,zero_results:Number(d.count)===0});
 });
 document.addEventListener('change',event=>{
  const field=event.target?.dataset?.nativeFilter;
  if(['size','designer','silhouette','fabric','neckline','color','stock','price','sort'].includes(field))publish('filter_used',{filter_name:field,has_value:!!event.target.value});
 });
 document.addEventListener('click',event=>{
  const link=event.target.closest?.('a[href]');if(!link)return;
  let url;try{url=new URL(link.href,location.href);}catch{return;}if(url.origin!==location.origin)return;
  const onHome=!!document.getElementById('midnight-hero');
  if(url.pathname.startsWith('/products/'))publish('gown_opened',{source:onHome?'home':'collection',product_handle:url.pathname.split('/')[2]});
  else if(url.pathname.startsWith('/collections/'))publish('collection_opened',{source:onHome?'home':'navigation',size_entry:url.searchParams.has('mb_size'),drop_entry:!!link.closest('.drop-section')});
 });
 const count=document.querySelector('[data-native-count]');if(count)publish('collection_results',{result_count:Number(count.textContent)||0,has_search:!!document.querySelector('#CollectionQuery')?.value,has_filters:!!document.querySelector('[data-native-filter-state]')?.textContent,zero_results:Number(count.textContent)===0});
 if(document.querySelector('[data-drop-success]'))publish('drop_signup_confirmed',{source:'homepage'});
})();
